import React, { ReactNode } from 'react';
import { Grid } from 'theme-ui';
import ImgLoader from '~/components/Generic/ImgLoader';
import ProductLink from '~/components/Product/Link';
import { BundleSpotlight, KitSpotlight, ProductSpotlight } from '../utils';

type Props = {
  children: ReactNode;
  spotlight: ProductSpotlight | BundleSpotlight | KitSpotlight;
  layout: 'horizontal' | 'vertical';
  colorQuery?: string | null;
  variantImage?: Queries.ImageFragment | null;
  badge?: Queries.BadgeFragment | null;
};

const QuickshopCardWrapper = ({ children, spotlight, colorQuery, layout, variantImage, badge }: Props) => {
  const verticalRows = `minmax(1.8rem, max-content) minmax(4rem, max-content) 2.4rem 1.6rem 1fr 3.2rem 4rem`;
  const verticalAreas = `"name" "swatch" "microload" "." "description" "." "cta"`;
  const horizontalRows = '2.4rem 3.2rem 1.8rem 2.1rem 1.6rem 1fr 1.6rem 3.2rem';
  const horizontalAreas = `"swatch" "." "name" "microload" "." "description" "." "cta"`;

  return (
    <Grid
      sx={{
        gridTemplateColumns: ['1fr', layout === 'horizontal' ? '1fr 1fr' : '1fr'],
        gridTemplateRows: layout === 'horizontal' ? '1fr' : 'auto 1fr',
        gap: layout === 'horizontal' ? '2.4rem' : '1.6rem',
        p: ['2.4rem', '1.6rem', '2.4rem'],
        backgroundColor: spotlight?.backgroundColor,
      }}
    >
      <ProductLink
        productName={spotlight?.content?.name}
        productSlug={spotlight?.content?.slug}
        collectionSlug={spotlight?.content?.collection?.[0]?.slug}
        locationDetail={'Quickshop'}
        qs={colorQuery ?? ''}
      >
        <ImgLoader
          image={variantImage ?? spotlight.mainImage}
          forwardSx={{ aspectRatio: '1/1', width: '100%' }}
          badge={badge}
        />
      </ProductLink>
      <Grid
        sx={{
          gridTemplateAreas: [verticalAreas, layout === 'horizontal' ? horizontalAreas : verticalAreas],
          gridTemplateRows: [verticalRows, layout === 'horizontal' ? horizontalRows : verticalRows],
          gap: 0,
          pt: [0, layout === 'horizontal' ? '2.4rem' : 0],
          position: 'relative',
        }}
      >
        {children}
      </Grid>
    </Grid>
  );
};

export default QuickshopCardWrapper;
